export default defineNuxtRouteMiddleware(async (to) => {
  const { client, setClient } = useClientStore();

  const handlePriorityRedirect = async (priorityProjectId?: string | null) => {
    if (!priorityProjectId || to.query.force === "true") return;

    const entryPaths = ["/", "/client", "/client/projects"];
    const entryNames = ["index", "client", "client-projects"];

    const pathWithoutLocale = to.path.replace(/^\/(ru|en|ka|uz)(\/|$)/, "/");

    if (entryPaths.includes(pathWithoutLocale) || entryNames.includes(to.name as string)) {
      if (process.client) {
        await nextTick();
      }

      const { createAppLink } = useAppLink();
      const targetUrl = createAppLink("/admin", "crm", priorityProjectId);

      if (process.client && window.Telegram?.WebApp?.initData) {
        const { createTelegramWebAppLink } = useTelegramWebAppLink();
        const telegramLink = createTelegramWebAppLink(targetUrl);
        const tg = (window as any).Telegram?.WebApp;

        if (tg?.openTelegramLink) {
          tg.openTelegramLink(telegramLink);
        } else {
          window.open(telegramLink, "_blank");
        }

        setTimeout(() => {
          tg?.close?.();
        }, 300);

        return abortNavigation();
      }

      return navigateTo(targetUrl, { external: true });
    }
    };

    if (client.value) {
    return handlePriorityRedirect(client.value.priority_project_domain);
    }

    const { tokenState } = useAuthStore();
    const { getRefreshToken, removeRefreshToken } = useAuthToken();
    const { refreshToken } = getRefreshToken();

    if (refreshToken.value && tokenState.value.accessToken) {
    const { item } = await useGetClientDto();

    if (item.value) {
      setClient(item.value);
      const redirect = await handlePriorityRedirect(item.value.priority_project_domain);
      if (redirect) return redirect;
    }

    if (!item.value) {
      const { createAppLink } = useAppLink();
      const { hash, pathname, search } = useRequestURL();
      const redirectLink = createAppLink("/", "main");
      const redirectToLink = createAppLink(pathname + search + hash, "main");

      removeRefreshToken();

      return navigateTo(
        {
          path: redirectLink,
          query: {
            modal: SHARED_MODAL.AuthLogin,
            [SHARED_URL_QUERY_PARAMETERS.RedirectTo]: redirectToLink,
          },
        },
        {
          external: true,
        },
      );
    }
  }
});
